import React from 'react'
import ReactDOM from 'react-dom/client'
import CssBaseline from '@mui/material/CssBaseline'
import { AuthProvider } from 'contexts/AuthContext'
import App from 'App'
import 'styles/index.css'
import { ThemeProvider } from 'contexts/ThemeContext'
import 'styles/theme.css'
import 'styles/workspace.css'
import 'styles/operations.css'
import 'styles/responsive.css'
import 'styles/buttons.css'

const element = document.getElementById('root') as HTMLElement
const root = ReactDOM.createRoot(element)

root.render(
  <React.StrictMode>
    <ThemeProvider><AuthProvider>
      <CssBaseline />
      <App />
    </AuthProvider></ThemeProvider>
  </React.StrictMode>
)
